import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/pc/');

export default function Comp() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const [isCharging, setIsCharging] = useState(false);

    // useEffect(() => {
    //     const sceneA1 = new ScrollMagic.Scene({
    //         triggerElement: `.animationG`,
    //         offset: -200, //从开始点滚动多少px触发,可为负数
    //         triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
    //         duration: '0%', //和滚动条绑定到一起,场景持续滚动距离为 800px
    //     });

    //     sceneA1.on('enter', function () {
    //         setIsCharging(true);
    //     });
    //     sceneA1.on('leave', function () {
    //         setIsCharging(false);
    //     });
    //     // @ts-ignore
    //     controllerDelta2?.addScene(sceneA1);
    // }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsCharging(true);
                    } else {
                        setIsCharging(false);
                    }
                });
            }).observe(document.querySelector('.animationG .process-box')!);
        }
    }, []);

    return (
        <div className={`${css.animationG} animationG GtmModuleData-section`} data-section-id={css.animationG} data-section-title={t('delta2.aniG_msg1')}>
            <div className="static-box">
                <div className="img-box">
                    <EFPic name={['animG.webp', 'animG.jpg']} />
                </div>
                <div className="content-box">
                    <div className="msg-box">
                        <div className="msg-title1">{t('delta2.aniG_msg1')}</div>
                        <div className="msg-title2 title-bolder">
                            <span>{t('delta2.aniG_msg2')}</span>
                            <span className="color-blue">{t('delta2.aniG_msg3')}</span>
                            <span>{t('delta2.aniG_msg4')}</span>
                        </div>
                        <div className="msg-title3">
                            {t.rich('delta2.aniG_msg5', {
                                line1: (text: string) => (
                                    <Link className="ef-link__page" href="/x-stream" newWin>
                                        {text}
                                    </Link>
                                ),
                            })}
                        </div>
                        <div className="msg-title4">{t('delta2.aniG_msg6')}</div>
                    </div>
                    <div className="process-box">
                        <div className="delta2">
                            <div className="left">
                                <div className={`${isCharging ? 'bar-charging' : ''} bar`}>
                                    <span className="name">{t('delta2.aniG_msg7')}</span>
                                    <div className="time">
                                        <span>{t('delta2.aniG_num1')} </span>
                                        <span>{t('delta2.aniG_msg13')}</span>
                                    </div>
                                </div>
                                <div className="desc">{t('delta2.aniG_msg8')}</div>
                            </div>
                            <div className="right">
                                <div className="text1">{t('delta2.aniG_num2')}</div>
                                <div className="text2">{t('delta2.aniG_msg9')}</div>
                            </div>
                        </div>
                        <div className="others">
                            <div className={`${isCharging ? 'bar-charging' : ''} bar`}>
                                <span className="name">{t('delta2.aniG_msg10')}</span>
                                <div className="time">
                                    <span>{t('delta2.aniG_num3')}</span>
                                    <span>{t('delta2.aniG_msg11')}</span>
                                </div>
                            </div>
                            <div className="desc">{t('delta2.aniG_msg12')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
